<template>
    <div class="UtilsActions" v-show="item.id != ''">
        <v-btn class="ma-2" tile outlined small color="indigo" @click="openMailDialog()" v-if="hasItemUser" :loading="sendingMails">
            <v-icon left>{{mdiEmailSend}}</v-icon> Mail
        </v-btn>
        <v-btn class="ma-2" tile outlined small color="indigo" @click="printPdf()">
            <v-icon left>{{mdiFilePdf}}</v-icon> PDF
        </v-btn>
        <v-btn class="ma-2" tile outlined small color="indigo" @click="printPaper()"  v-if="!getAuth.isAdmin">
            <v-icon left>{{mdiPrinter}}</v-icon> Yazdır
        </v-btn>
        <v-menu offset-y  v-if="getAuth.isAdmin">
            <template v-slot:activator="{ on }"> 
				 <v-btn class="ma-2" tile outlined small color="indigo" v-on="on">
					<v-icon left>{{mdiPrinter}}</v-icon> Yazdır
				</v-btn>
            </template>
            <v-list dense> 
                <v-list-item @click="printPaper()">
                    <v-list-item-title><v-icon left>{{mdiFile}}</v-icon> Antetli</v-list-item-title>
                </v-list-item>
                <v-list-item @click="printPaperEmpty()">
                    <v-list-item-title><v-icon left>{{mdiFileOutline}}</v-icon> Şablonsuz</v-list-item-title>
                </v-list-item> 
            </v-list>
        </v-menu>


        <v-dialog v-model="showMailDialog" persistenxt max-width="600">
            <v-card>
                <v-card-title class="headline">Mail ile bildir</v-card-title>
                <v-card-text v-if="hasItemUser">
                    Bu bildirimi kimlere gönderceksiniz
                    <v-checkbox v-for="(mailto, mailtoIndex) in sendMailTo" :key="mailtoIndex" v-model="mailto.send" :label="mailto.name" class="mb-0" hide-details color="green"></v-checkbox>
                    <br>
                    <br>
                    <br>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="orange " outlined @click="showMailDialog = false">İptal</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="indigo " outlined @click="sendMails()" :loading="sendingMails" :disabled="sendingMails">Gönder</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="actionDialogShow" :color="actionDialogColor" :timeout="3000" top>
            {{ actionDialogText }}
            <v-btn dark text @click="actionDialogShow = false">
                Tamam
            </v-btn>
        </v-snackbar>

    </div>
</template>
<script>
    import {
        mdiEmailSend,
        mdiFilePdf,
        mdiPrinter,
        mdiFile,
        mdiFileOutline,
    } from '@mdi/js';
    export default {
        props: {
            item: {
                type: Object
            },
            module: {
                default: ""
            },
        },
        data: () => ({
            mdiEmailSend: mdiEmailSend,
            mdiFilePdf: mdiFilePdf,
            mdiPrinter: mdiPrinter,
            mdiFile: mdiFile,
            mdiFileOutline: mdiFileOutline,

            users: [],

            showMailDialog: false,
            sendMailTo: [],
            sendingMails: false,
            actionDialogShow: false,
            actionDialogText: "",
            actionDialogColor: "",
        }),
        watch: {
            getItemUser: function(user) {
                this.sendMailTo = []
                this.sendMailTo.push({
                    email: user.email,
                    name: user.fullname + " (" + user.email + ")" + " (Müşteri maili)",
                    send: false,
                })
                for (var i in user.subusers) {
                    var subuser = user.subusers[i];
                    var name = subuser.firstname + " " + subuser.lastname + " (" + subuser.email + ")";
                    if (subuser.department != "") {
                        name += " (" + subuser.department + ")"
                    }
                    this.sendMailTo.push({
                        email: subuser.email,
                        name: name,
                        send: false,
                    })
                }
            }
        },
        mounted() {
            this.loadUsers()
        },
        methods: {
            loadUsers() {
                this.$http.get(process.env.VUE_APP_API_URL + "/users/", {
                    params: {}
                }).then(response => {
                    this.users = response.body;
                })
            },
            openMailDialog() {
                this.showMailDialog = true
            },
            sendMails() {
                this.sendingMails = true
                this.$http.post(process.env.VUE_APP_API_URL + "/sendmail/" + this.module, {
                    module: this.module,
                    item: this.item,
                    sendMailTo: this.sendMailTo
                }).then(response => {
                    if (response.body.success) {
                        this.actionDialogShow = true;
                        this.actionDialogText = "Mailler gönderildi"
                        this.actionDialogColor = "green"
                    } else {
                        this.actionDialogShow = true;
                        this.actionDialogText = "Mail gönderme başarısız"
                        this.actionDialogColor = "red"
                    }
                    this.sendingMails = false
                    this.showMailDialog = false
                })


            },
            printPdf() {
                window.open(process.env.VUE_APP_API_URL + "/view/" + this.module + "?pdf=1&token=" + this.item.token, '_blank');
            },
            printPaper() {
                window.open(process.env.VUE_APP_API_URL + "/view/" + this.module + "?print=1&token=" + this.item.token, '_blank');
            },
            printPaperEmpty() {
                window.open(process.env.VUE_APP_API_URL + "/view/" + this.module + "?print=1&noheader=1&token=" + this.item.token, '_blank');
            },

        },
        computed: {
            hasItemUser() {
                return this.getItemUser !== false
            },
            getItemUser() {
                for (var i in this.users) {
                    if (this.users[i].id == this.item.user_id) {
                        return this.users[i]
                    }
                }
                return false;
			},
			getAuth(){
				return this.$store.getters.getAuth;
			}
        }, 
    }
</script>
<style lang="less">
    .UtilsActions {
        display: inline-block;
    }
</style>